export function simpleCharacterNormalization(value: string) {
  const lowered = value
    // Decompose every Unicode character into its compatibility representation.
    .normalize('NFKD')
    // Remove any Unicode modifier character generated by the decomposition.
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  return (
    lowered
      .replaceAll('œ', 'oe')
      .replaceAll('ø', 'o')
      .replaceAll('ł', 'l')
      .replaceAll('æ', 'ae')
      .replaceAll('ß', 'ss')

      // Those zero-width characters are stripped by Elasticsearch.
      .replaceAll('\u200C', '')
      .replaceAll('\u200D', '')
      .replaceAll('\uFEFF', '')
  );
}

/**
 * Checks if `value` contains a character that is not a printable ASCII character.
 */
export function containsNonSupportedCharacter(value: string) {
  return /[^\s!"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~A-Za-z0-9]/.test(value);
}

export function splitOnNonAlphaNum(value: string) {
  // Not using \W as it also excludes `_`. We want to split on `_`.
  return value.split(/[^A-Za-z0-9]+/);
}

export function splitOnWhitespace(value: string) {
  // Elasticsearch also splits on U+200B (ZERO WIDTH SPACE), but \s doesn't include it.
  return value.split(/[\s\u200B]+/);
}
